import React from 'react';
import {NavLink, useLocation} from "react-router-dom";
import css from '../css/NavigationLink.module.css'
import ConditionalRender, {Fallback} from "../../ConditionalRender";

const NavigationLink = ({ text, Icon, IconActive = Icon, to, queryParams = {}, activeLinks = [], strict = false, strictParams = false }) => {
    const location = useLocation();

    const constructQueryString = (params) => {
        const searchParams = new URLSearchParams(params);
        return searchParams.toString() ? `?${searchParams.toString()}` : '';
    };

    const doQueryParamsMatch = () => {
        if (!strictParams)
            return true; // Skip strict query check if not enabled

        const currentParams = new URLSearchParams(location.search);
        return Object.entries(queryParams).every(([key, value]) => currentParams.get(key) === value);
    };

    const linkIsActive = (link) => location.pathname.includes(link);

    // Check if the current path matches any of the alternative links
    const isAltLinkActive = () => activeLinks.some(link => linkIsActive(link));

    // Check if the current path matches strictly
    const isStrictLinkActive = () => location.pathname.endsWith(to) && doQueryParamsMatch();

    const isActive = strict ? isStrictLinkActive() : linkIsActive(to) || isAltLinkActive();

    const getClassName = () => {
        const isActiveState = strict ? isStrictLinkActive() : isActive || isAltLinkActive();
        return `${css.wrapper} ${isActiveState ? css.wrapperActive : css.wrapperInactive} user-select-none`;
    };

    const fullPath = `${to}${constructQueryString(queryParams)}`;

    return (
        <NavLink to={fullPath} className={getClassName()}>
            <div className={css.textAndIcon}>
                <ConditionalRender condition={isActive}>
                    <Fallback>
                        <Icon className="me-2" size={20} />
                    </Fallback>
                    {IconActive ? <IconActive className="me-2" size={20} /> : Icon && <Icon className="me-2" size={20} />}
                </ConditionalRender>
                <span>{text}</span>
            </div>
        </NavLink>
    );
};

export default NavigationLink;